
const warehousesaleDt = require('./warehousesale-dt')
const warehousesalePage = require('./warehousesale-page')
const warehousesaleFullcont = require('./warehousesale-fullcont')
const warehousesaleFullcontConfirm = require('./warehousesale-fullcont-confirm')
const saleBackdrop        = require('./warehousesale-backdrop')

const saleConfirmation    = require('./warehousesale-confirmation')
const saleDialog          = require('./warehousesale-dialog')
const saleDt              = require('./warehousesale-dt')
const saleFullcont        = require('./warehousesale-fullcont')
// const saleFullcontStepper = require('./sale-fullcont-stepper')
const saleMenu            = require('./warehousesale-menu')
const saleMT              = require('./warehousesale-fullcont-multitable')
const salePage            = require('./warehousesale-page')
const saleSnack           = require('./warehousesale-snack')
const saleKey             = require('./warehousesale-key')
const warehousesaleQuickform =  require('./warehousesale-quickform')

export function start(detail){   //console.log('goku-dt 5>', detail)
      
      obj[detail.elem].start(detail)

}/**/

const obj = {

      dt:            { start: (detail)=>{  warehousesaleDt.start(detail)             }},
      page:          { start: (detail)=>{  warehousesalePage.start(detail)           }},
      fullcont:      { start: (detail)=>{  warehousesaleFullcont.start(detail)      }},
      confirmItems:   { start: (detail)=>{  warehousesaleFullcontConfirm.start(detail)    }},
      multitable:      { start: (detail)=>{  saleMT.start(detail)               }},
      menu:            { start: (detail)=>{  saleMenu.start(detail)             }},
      snack:           { start: (detail)=>{  saleSnack.start(detail)            }},
      key:             { start: (detail)=>{  saleKey.start(detail)              }},
      confirmation:    { start: (detail)=>{  saleConfirmation.start(detail)     }},
      dialog:          { start: (detail)=>{  saleDialog.start(detail)           }},
      backdrop:        { start: (detail)=>{  saleBackdrop.start(detail)         }},
      quickform:       { start: (detail)=>{  warehousesaleQuickform.start(detail)        }},
}








